"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _passthroughProps = _interopRequireDefault(require("UIComponents/utils/propTypes/passthroughProps"));

var _default = _react.default.createClass({
  displayName: "EmojiPickerWrapper",
  propTypes: {
    children: _react.PropTypes.node,
    emojiSize: _react.PropTypes.number,
    perLine: _react.PropTypes.number,
    showSkinTones: _react.PropTypes.bool,
    popoverProps: (0, _passthroughProps.default)(_UIPopover.default),
    unicodeVersion: _react.PropTypes.number,
    customEmojiFilter: _react.PropTypes.func,
    useDefaultFilter: _react.PropTypes.bool,
    storeHandlers: _react.PropTypes.shape({
      getter: _react.PropTypes.func,
      setter: _react.PropTypes.func
    }),
    PickerContent: _react.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      emojiSize: 24,
      perLine: 7,
      showSkinTones: true,
      unicodeVersion: 8.0,
      useDefaultFilter: true
    };
  },
  setPickerContentRef: function setPickerContentRef(c) {
    this.pickerContent = c;
  },
  focus: function focus() {
    this.pickerContent.focus();
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        emojiSize = _this$props.emojiSize,
        perLine = _this$props.perLine,
        popoverProps = _this$props.popoverProps,
        PickerContent = _this$props.PickerContent,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "emojiSize", "perLine", "popoverProps", "PickerContent"]); // width calculation borrowed from emoji-mart

    var pickerWidth = popoverProps && popoverProps.width || perLine * (emojiSize + 12) + 12 + 2 + 30;
    return _react.default.createElement(_UIPopover.default, (0, _extends2.default)({}, popoverProps, {
      content: _react.default.createElement(PickerContent, (0, _extends2.default)({
        ref: this.setPickerContentRef
      }, rest)),
      width: pickerWidth
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;